import _objectSpread from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Task } from "../api";
import { BaseResource } from "@kgsport-cms/common";
import "../common";
/**
 *
 * 任务系统
 *
 */
export var TaskService = /*#__PURE__*/function (_BaseResource) {
  _inherits(TaskService, _BaseResource);
  var _super = _createSuper(TaskService);
  function TaskService() {
    _classCallCheck(this, TaskService);
    return _super.apply(this, arguments);
  }
  _createClass(TaskService, [{
    key: "types",
    value:
    // 任务板块
    function types() {
      return this.requester.get(Task.types);
    }
    // 任务列表
  }, {
    key: "list",
    value: function list(params) {
      return this.requester.get(Task.list, {
        params
      });
    }
    // 参加任务
  }, {
    key: "apply",
    value: function apply(params) {
      return this.requester.post(Task.apply, _objectSpread({}, params));
    }
    // 参加任务
  }, {
    key: "applyExt",
    value: function applyExt(params) {
      return this.requester.post(Task.applyExt, _objectSpread({}, params));
    }
  }]);
  return TaskService;
}(BaseResource);